import { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function CTASection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-white py-24 lg:py-32">
      <div className="max-w-6xl mx-auto px-6">
        <div className="relative bg-[#191F28] rounded-[2.5rem] overflow-hidden px-10 py-20 lg:px-20 text-center">
          {/* Real photo as subtle BG */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <img
              src="https://storage.readdy-site.link/project_files/1dd47190-5ea2-431c-a9ac-432354462ac6/e32b9269-066f-449e-8013-759c01048f22_ec7d1e9dd74ec5af65c12cb2fe448cd4756c5390.png?v=050081879659d0caf3c5e11302fdc1dc"
              alt=""
              className="w-full h-full object-cover object-top opacity-[0.12]"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#191F28] via-[#191F28]/80 to-[#191F28]" />
            <div className="absolute inset-0 bg-gradient-to-b from-[#191F28]/60 via-transparent to-[#191F28]/60" />
          </div>
          {/* Accent glows */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute -top-20 -right-20 w-80 h-80 bg-[#00D873]/10 rounded-full" />
            <div className="absolute -bottom-16 -left-16 w-64 h-64 bg-[#00D873]/5 rounded-full" />
          </div>

          <div
            className={`relative z-10 transition-all duration-700 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            <div className="inline-flex items-center gap-2 bg-[#00D873]/20 text-[#00D873] px-4 py-2 rounded-full text-sm font-semibold mb-8">
              <span>🚀</span>
              <span>무료로 시작하세요</span>
            </div>

            <h2 className="text-4xl lg:text-6xl font-black text-white mb-8 leading-relaxed lg:leading-relaxed">
              지금 당장 첫 수익을
              <br />
              <span className="text-[#00D873]">AI로 만드세요</span>
            </h2>

            <p className="text-white/60 text-lg mb-12 max-w-lg mx-auto leading-[1.9]">
              보고서·이모티콘·쇼츠 하나만 완성해도<br />
              N잡의 시작, 칼퇴의 시작이 됩니다.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/dashboard"
                className="bg-[#00D873] text-white font-bold text-lg px-12 py-4 rounded-full hover:opacity-90 transition-all duration-200 hover:-translate-y-1 whitespace-nowrap cursor-pointer"
              >
                첫 수익 챌린지 시작하기
              </Link>
              <Link
                to="/community"
                className="text-white/70 font-medium hover:text-white transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                수익 인증 라운지 보기 <i className="ri-arrow-right-line" />
              </Link>
            </div>

            {/* Guarantees */}
            <div className="flex flex-wrap items-center justify-center gap-6 mt-12 text-white/40 text-sm">
              {["신용카드 불필요", "하루 15분이면 충분", "첫 수익까지 평균 3주"].map((t) => (
                <div key={t} className="flex items-center gap-2">
                  <i className="ri-check-line text-[#00D873]" />
                  <span>{t}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
